/**
 * QR helper for the share-card export.
 *
 * Generates a real, scannable QR code as a data URL via the `qrcode`
 * library, then loads it as an `HTMLImageElement` so the canvas
 * draw step is synchronous. Cached per-URL — the share card always
 * points to the same destination, so the result is computed once
 * per page lifetime.
 */

import QRCode from "qrcode";
import { loadImage } from "./canvas";

const cache = new Map<string, Promise<HTMLImageElement>>();

export function qrToImage(url: string): Promise<HTMLImageElement> {
  const hit = cache.get(url);
  if (hit) return hit;
  const promise = (async () => {
    const dataUrl = await QRCode.toDataURL(url, {
      margin: 0,
      errorCorrectionLevel: "M",
      width: 256,
      color: {
        dark: "#0a0220ff",
        light: "#ffffffff",
      },
    });
    return loadImage(dataUrl);
  })();
  cache.set(url, promise);
  return promise;
}
